"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Footer(props) {
  var i18n = props.i18n,
      urls = props.urls;


  return _react2.default.createElement(
    "div",
    { id: "footer" },
    _react2.default.createElement(
      "div",
      { className: "nav-primary" },
      _react2.default.createElement(
        "div",
        { className: "width-base" },
        _react2.default.createElement(
          "ul",
          { className: "list-nav" },
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement(
              "a",
              { href: urls.external.sitemap },
              i18n.footer.sitemap
            )
          ),
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement(
              "a",
              { href: urls.external.privacy },
              i18n.footer.privacy
            )
          ),
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement(
              "a",
              { href: urls.external.conditions },
              i18n.footer.terms
            )
          ),
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement(
              "a",
              { href: urls.external.faq },
              i18n.footer.faq
            )
          ),
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement(
              "a",
              { href: urls.external.about },
              i18n.footer.about
            )
          )
        ),
        _react2.default.createElement(
          "small",
          { className: "copyright" },
          i18n.footer.copyright
        )
      )
    )
  );
} // Footer

Footer.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  urls: _react.PropTypes.object.isRequired
};

exports.default = Footer;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer.js
// module id = 1201
// module chunks = 0